import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const ApiPeople = () => {
  const getSummary = async (DimDate) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _DimDate = DimDate.slice();
    const allIndex = _DimDate.indexOf('All');
    if (allIndex > -1) _DimDate.splice(allIndex, 1);
    let filter = { DateKeys: _DimDate };

    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/people/${company_id}/${company_org_id}/summary${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getDetail = async (DimDate) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _DimDate = DimDate.slice();
    const allIndex = _DimDate.indexOf('All');
    if (allIndex > -1) _DimDate.splice(allIndex, 1);
    let filter = { DateKeys: _DimDate };

    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/people/${company_id}/${company_org_id}/detail${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getSummary,
    getDetail,
  };
};

export default ApiPeople();
